<template>
  <UModal 
    v-model:open="isOpen"
    :dismissible="false"
    :ui="{ 
      content: 'sm:max-w-md',
      header: 'bg-gray-50 text-gray-700 p-2 sm:py-2 min-h-10',
      body: 'p-2',
      footer: 'bg-gray-50 px-2 sm:px-2 py-2 flex justify-end'
    }"
  >
    <template #header>
      <div class="flex items-center">
        <h3 class="text-sm text-semibold">Session expirée</h3>
      </div>
    </template>

    <template #body>
      <div class="space-y-4">
        <p class="text-gray-600 text-sm">
          Veuillez vous reconnecter pour continuer à utiliser l'application.
        </p>
      </div>
    </template>

    <template #footer>
      <UButton
        label="Se reconnecter"
        color="primary"
        size="lg"
        @click="handleReconnect"
      />
    </template>
  </UModal>
</template>

<script setup lang="ts">
interface Props {
  show: boolean
  message?: string
}

interface Emits {
  (e: 'reconnect'): void
}

const props = withDefaults(defineProps<Props>(), {
  message: 'Votre session a expiré.'
})

const emit = defineEmits<Emits>()

// Synchroniser avec le prop show
const isOpen = computed({
  get: () => props.show,
  set: (value) => {
    if (!value) {
      emit('reconnect')
    }
  }
})

const handleReconnect = () => {
  emit('reconnect')
}
</script>
